import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import queryString from 'query-string';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import SearchButton from '../../components/atoms/SearchButton';
import ReleaseTable from '../organisms/ReleaseTable';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getShops } from '../../actions/Shop';
import { getAccounts } from '../../actions/Accounts';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textField150: {
    padding: '0px 5px 0px 5px',
    width: '200px'
  },
  button: {
    margin: '5px 5px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      shops: state.shops.shops
    }),
    dispatch => ({
      actions: bindActionCreators({ getShops, getAccounts }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('shopName', 'setShopName', ''),
  withState('shopId', 'setShopId', ''),
  withState('groupName', 'setGroupName', ''),
  withState('address', 'setAddress', ''),
  withState('unreleased', 'setUnreleased', 'true'),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangePage: props => async (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }

      const searchKey = {
        shopName: props.shopName,
        shopId: props.shopId,
        groupName: props.groupName,
        address: props.address,
        unreleased: props.unreleased,
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      await props.actions
        .getShops(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          props.updateOpenProgress(false);
          props.updateLoading(false);
          props.updateOpenTable(true);
        })
        .catch(() => {
          props.updateOpenProgress(false);
          props.updateLoading(false);
        });
      const url = `?shopName=${props.shopName}&groupName=${
        props.groupName
      }&address=${props.address}&unreleased=${
        props.unreleased
      }&page=${page}&limit=${limit}`;
      props.history.push(`/releases${url}`);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
        if (data.payload.role === 'SHOP') {
          this.props.actions
            .getShops({
              page: this.props.page,
              limit: this.props.rowsPerPage
            })
            .then(shopData => this.props.checkSession(shopData));
          this.props.updateOpenTable(true);
        }

        const urlParams = queryString.parse(this.props.location.search);
        console.log(urlParams);
        if (Object.keys(urlParams).length > 0) {
          const table = document.getElementById('scrollTableId');
          if (table !== null) {
            table.scrollTop = 0;
          }
          this.props.setPage(urlParams.page);

          const rowsPerPage = document.getElementById('rowsPerPage');
          let limitNum = 100;
          if (rowsPerPage) {
            limitNum = rowsPerPage.textContent;
          }

          const searchKey = {
            shopName: urlParams.shopName,
            shopId: urlParams.shopId,
            groupName: urlParams.groupName,
            address: urlParams.address,
            unreleased: urlParams.unreleased,
            page: urlParams.page,
            limit: urlParams.limit || limitNum
          };

          this.props.updateLoading(true);
          this.props.updateOpenProgress(true);
          await this.props.actions
            .getShops(searchKey)
            .then(shopData => {
              this.props.checkSession(shopData);
              this.props.updateOpenProgress(false);
              this.props.updateLoading(false);
              this.props.updateOpenTable(true);
              this.props.setShopName(urlParams.shopName);
              this.props.setShopId(urlParams.shopId);
              this.props.setGroupName(urlParams.groupName);
              this.props.setAddress(urlParams.address);
              this.props.setUnreleased(urlParams.unreleased);
              this.props.setPage(urlParams.page);
              this.props.setLimit(urlParams.limit);
            })
            .catch(() => {
              this.props.updateOpenProgress(false);
              this.props.updateLoading(false);
            });
        }
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    account,
    handleChangePage,
    openDrawer,
    updateOpenDrawer,
    openTable,
    updateOpenTable,
    loading,
    openProgress,
    shopName,
    setShopName,
    shopId,
    setShopId,
    groupName,
    setGroupName,
    address,
    setAddress,
    unreleased,
    setUnreleased,
    page,
    updateLoading,
    updateOpenProgress
  }) => {
    // const searchKey = {
    //   shopName,
    //   groupName,
    //   address,
    //   unreleased
    // };
    const searchAction = async () => {
      updateOpenTable(true);
      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }
      handleChangePage(null, 1, limitNum);

      // updateLoading(true);
      // updateOpenProgress(true);
      // await actions
      //   .getShops(searchKey)
      //   .then(data => {
      //     checkSession(data);
      //     updateOpenProgress(false);
      //     updateLoading(false);
      //     handleChangePage(null, 0);
      //     updateOpenTable(true);
      //   })
      //   .catch(() => {
      //     updateOpenProgress(false);
      //     updateLoading(false);
      //   });
    };

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress
    };
    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            店舗状況検索
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchForm}>
            <div>
              <TextField
                label="運営会社名"
                placeholder="部分一致"
                type="search"
                className={classes.textField}
                margin="normal"
                value={groupName}
                onChange={e => {
                  setGroupName(e.target.value);
                }}
              />
              <TextField
                label="店舗ID"
                placeholder="部分一致"
                type="search"
                className={classes.textField}
                margin="normal"
                value={shopId}
                onChange={e => {
                  setShopId(e.target.value);
                }}
              />
            </div>
            <div>
              <TextField
                label="店舗名"
                placeholder="部分一致"
                type="search"
                className={classes.textField}
                margin="normal"
                value={shopName}
                onChange={e => {
                  setShopName(e.target.value);
                }}
              />
              <TextField
                label="住所"
                placeholder="部分一致"
                type="search"
                className={classes.textField}
                margin="normal"
                value={address}
                onChange={e => {
                  setAddress(e.target.value);
                }}
              />
            </div>
            <div>
              <RadioGroup
                row
                value={unreleased}
                onChange={e => {
                  setUnreleased(e.target.value);
                }}
              >
                <FormControlLabel
                  value="true"
                  control={<Radio color="primary" />}
                  label="開店してない店舗"
                />
                <FormControlLabel
                  value="false"
                  control={<Radio color="primary" />}
                  label="全て"
                />
              </RadioGroup>
            </div>
            <div>
              <div>
                <SearchButton onClickAction={searchAction} />
              </div>
            </div>
          </div>
          {openTable && (
            <ReleaseTable
              page={page}
              handleChangePage={handleChangePage}
              selectedPage={page}
              progress={progress}
            />
          )}
        </Paper>
        <ProgressDialog openProgress={openProgress} loading={loading} />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
